<section class="p-2">
    
    <div class="flex flex-column mt-3">
        <div class="flex justify-content-between align-items-center h-3rem p-4 border-round-top-lg" style="background-color: #F5F5F5; color: #585050">
            <h6 class="text-xs">Tipo</h6>
            <div class="flex justify-content-center align-items-center w-8rem h-2rem">
                <h6 class="text-xs">Liberação</h6>
            </div>
        </div>
        <div class="flex flex-column ">
            <div class="h-4rem flex justify-content-between align-items-center px-4" style="border-bottom: 1px solid #DDD;">
                <h4 class="title-text">
                    Fotografia
                </h4>
                <input type="file" name="anexar" id="anexar" style="display: none">
                <label for="anexar" class="button-text label-upload flex justify-content-center align-items-center w-8rem h-2rem border-round-md">
                    <img src="assets\cadastrar-profissionais\upload.svg" alt="upload" class="w-1rem mr-2"> Anexar
                </label>
            </div>

            <div class="h-4rem flex justify-content-between align-items-center px-4" style="border-bottom: 1px solid #DDD;">
                <h4 class="title-text">
                    Identidade
                </h4>
                <input type="file" name="anexar" id="anexar" style="display: none">
                <label for="anexar" class="button-text label-upload flex justify-content-center align-items-center w-8rem h-2rem border-round-md">
                    <img src="assets\cadastrar-profissionais\upload.svg" alt="upload" class="w-1rem mr-2"> Anexar
                </label>
            </div>

            <div class="h-4rem flex justify-content-between align-items-center px-4" style="border-bottom: 1px solid #DDD;">
                <h4 class="title-text">
                    Registro Profissional
                </h4>
                <input type="file" name="anexar" id="anexar" style="display: none">
                <label for="anexar" class="button-text label-upload flex justify-content-center align-items-center w-8rem h-2rem border-round-md">
                    <img src="assets\cadastrar-profissionais\upload.svg" alt="upload" class="w-1rem mr-2"> Anexar
                </label>
            </div>
        </div>
    </div>
</section>
<div class="grid m-0 p-fluid">
    <div class="col-6" >
        <split-select-week formControlName="weekSeg"></split-select-week>
    </div>
    <div class="col-6" >
        <split-select-week formControlName="weekTer"></split-select-week>
    </div>
    <div class="col-6" >
        <split-select-week formControlName="weekQua"></split-select-week>
    </div>
</div>